import { useCallback } from 'react';
import { Box, Grid } from 'theme-ui';
import Scroll from 'shared/Scroll';
import { ToolbarButton } from './toolbar/ToolbarButton';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveTool, setActiveTool } from 'modules/activeTool';
import { getCurrentScene } from 'modules/scenes';
import { ActiveTool, mapToolToItem } from 'types/AppState';
import { SceneType } from 'types/Scene';
import analytics from 'utils/analytics';
import { openSidebar } from 'modules/sidebar';
import { Sidebar } from 'types/Sidebar';
import { useTranslator } from '@picsart/rc/services/localization';

export const ToolBar = () => {
  const activeTool = useSelector(getActiveTool);
  const dispatch = useDispatch();
  const scene = useSelector(getCurrentScene);
  const translator = useTranslator();
  const selectToolHandler = useCallback((tool: ActiveTool) => {
    analytics.videoEditItemOpen(mapToolToItem[tool]);
    dispatch(openSidebar(Sidebar.ToolPanel));
    dispatch(setActiveTool(tool));
  }, []);

  return (
    <Box
      sx={{
        flex: '0 0 80px',
        position: 'relative',
        zIndex: 'toolBar'
      }}
      data-test="sidebar"
    >
      <div
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bg: 'background',
          borderRadius: '8px'
        }}
      >
        <Scroll>
          <Box sx={{ padding: '8px' }}>
            <Grid gap={3} columns={[1, null, 1]}>
              <ToolbarButton
                message={translator('Fit')}
                onClickHandler={() => selectToolHandler(ActiveTool.RatioFormat)}
                active={activeTool === ActiveTool.RatioFormat}
                icon="fit-editor"
                data-test="sidebar_fit"
              />
              {/* Templates are hidden according to PW-24741 */}
              {/* <ToolbarButton
                message={translator('Templates')}
                onClickHandler={() => selectToolHandler(ActiveTool.Templates)}
                active={activeTool === ActiveTool.Templates}
                icon="templates-editor"
                data-test="sidebar_templates"
              /> */}
              <ToolbarButton
                message={translator('Audio')}
                onClickHandler={() => selectToolHandler(ActiveTool.Audio)}
                active={activeTool === ActiveTool.Audio}
                icon="audio-editor"
                disabled={scene.type === SceneType.EMPTY}
                data-test="sidebar_audio"
              />
              <ToolbarButton
                message={translator('Text')}
                onClickHandler={() => selectToolHandler(ActiveTool.Text)}
                active={activeTool === ActiveTool.Text}
                icon="text-editor"
                disabled={scene.type === SceneType.EMPTY}
                data-test="sidebar_text"
              />
            </Grid>
          </Box>
        </Scroll>
      </div>
    </Box>
  );
};
